<h1 mat-dialog-title>Place a financing hold</h1>

<form [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <div mat-dialog-content class="place-financing-hold-dialog">
    <p class="hold-message">
      While a hold is active, no financing or final payment is made for the invoices it applies to,
      and they cannot be accepted out of Waiting for financing or Waiting for final payment.
      Each target you tick gets its own hold with the same reason,
      and each hold stays until a factoring handler or an administrator releases it with a note.
    </p>

    <div class="target-label" id="financing-hold-target-label">Place a hold on</div>
    <div
      class="target-options"
      role="group"
      formGroupName="targets"
      aria-labelledby="financing-hold-target-label"
    >
      <mat-checkbox
        *ngFor="let target of targets"
        class="target-option"
        [attr.data-scope]="target.scope"
        [formControlName]="target.scope"
      >
        {{ target.label }}
        <span class="target-held" *ngIf="target.heldMark">{{ target.heldMark }}</span>
      </mat-checkbox>
    </div>

    <mat-form-field class="full-width">
      <mat-label>Reason</mat-label>
      <textarea
        matInput
        rows="3"
        class="reason-input"
        placeholder="Why is financing stopped?"
        formControlName="reason"
      ></textarea>
      <mat-hint>Shown on the invoice to everyone who handles it.</mat-hint>
    </mat-form-field>

    <p class="error-message" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
    <button mat-button type="submit" color="warn" class="confirm-button" [disabled]="!canSubmit">{{ submitLabel }}</button>
  </div>
</form>
